import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'app-product-card-line-number',
  templateUrl: './product-card-line-number.component.html',
  styleUrls: ['./product-card-line-number.component.scss'],
})
export class ProductCardLineNumberComponent {
  @Input() sequenceNumber: number;
  @Input() isListManagement: boolean;
  @ViewChild('sequenceNumberRef') sequenceNumberRef: IonInput;

  @Output() resequenceProductEmitter: EventEmitter<number> = new EventEmitter();

  constructor() {}

  resequenceProduct(newValue: any) {
    if (newValue === '') {
      this.updateSequence(0);
      return;
    }

    const numValue = Number(newValue);
    if (!isNaN(numValue) && numValue >= 0) {
      if (numValue !== this.sequenceNumber) {
        this.resequenceProductEmitter.emit(numValue);
      }
      return;
    }

    setTimeout(() => {
      this.resetInputToCurrentValue();
    });
  }

  private updateSequence(value: number): void {
    if (value !== this.sequenceNumber) {
      this.resequenceProductEmitter.emit(value);
    }

    if (this.sequenceNumberRef) {
      this.sequenceNumberRef.value = value;
    }
  }

  private resetInputToCurrentValue(): void {
    if (this.sequenceNumberRef) {
      this.sequenceNumberRef.value = this.sequenceNumber;
    }
  }
}
